module.exports = __webpack_public_path__ + "ath_game_web/img/2.1.86121414.png";